/* jshint ignore:start */
  return $;
})(window, document);
/* jshint ignore:end */
